import { api } from './api';
import type { BgvPendingReview, BgvReviewResponse, BgvStatus, BgvSyncCheckrRequest, BgvSyncCheckrResponse } from '../types/bgv';

const BASE_PATH = '/bgv';

export const getPendingReviews = async (): Promise<BgvPendingReview[]> => {
  const response = await api.get(`${BASE_PATH}/admin/pending-reviews`);
  return response.data;
};

export const reviewUser = async (
  userId: number,
  body: { decision: 'approved' | 'denied'; reviewNotes?: string }
): Promise<BgvReviewResponse> => {
  const response = await api.post(`${BASE_PATH}/admin/review/${userId}`, body);
  return response.data;
};

export const getUserStatus = async (userId: number): Promise<BgvStatus> => {
  const response = await api.get(`${BASE_PATH}/status`, { params: { userId } });
  return response.data;
};

export const checkRequired = async (userId: number): Promise<{ required: boolean }> => {
  const response = await api.get(`${BASE_PATH}/check-required/${userId}`);
  return response.data;
};

export const syncCheckr = async (
  userId: number,
  body: BgvSyncCheckrRequest
): Promise<BgvSyncCheckrResponse> => {
  const response = await api.post(`${BASE_PATH}/admin/sync-checkr/${userId}`, body);
  return response.data;
};

export const bgvService = {
  getPendingReviews,
  reviewUser,
  getUserStatus,
  checkRequired,
  syncCheckr,
};

export default bgvService;
